import createClient from 'openapi-fetch';
import type { paths } from '@/types/api.generated';

const officeClient = createClient<paths>({
    baseUrl: process.env.NEXT_PUBLIC_API_URL || 'https://zakaz-backend.ttmf.ru',
});

// Офисные эндпоинты под OAuth2: токен подставляется лениво,
// oidc-чанк грузится только в браузере при реальном офис-запросе.
officeClient.use({
    async onRequest({ request }) {
        const { getAccessToken } = await import('@/helpers/auth');
        const token = await getAccessToken();
        if (token) request.headers.set('Authorization', `Bearer ${token}`);
        return request;
    },
});

export default officeClient;